import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "react-checkbox-tree/src/scss/react-checkbox-tree.scss";
import "highlight.js/styles/googlecode.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import axios from "axios";
import * as _redux from "./redux";
import store, { persistor } from "./redux/store";
import App from "./app/App";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import { MetronicLayoutProvider, MetronicSplashScreenProvider, MetronicSubheaderProvider } from "./_metronic/layout";
import { MetronicI18nProvider } from "./_metronic/i18n";
import { getDateTimeInZone } from "./app/modules/Common/utils";
import "./logout-style.css";
import { BANKING_BALANCE_VISIBILITY_KEY } from "./app/modules/Common/constants";
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const PUBLIC_URL = process.env.PUBLIC_URL;
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
// /*  const mock =  */
// _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

/**
 * Logic to clear cache and storage every day
 */
export const clearAppStorageAndCacheDaily = async () => {
  const lastClearDate = localStorage.getItem("lastClearDate");
  const state = store.getState();
   const timezone = state?.basicSettings?.entity?.Basic?.timezone;
  if (!timezone) return;
  // const todayString = new Date().toISOString().split("T")[0]; // just date
  const todayString = getDateTimeInZone(timezone).split("T")[0];
   const nextPollSinceTimestamp = localStorage.getItem("nextPollSinceTimestamp") || "";
  const preservePurchaseOrder = localStorage.getItem("persisted_purchase_orders");
  const preserveSaleOrder = localStorage.getItem("persisted_sale_orders");

   if (lastClearDate !== todayString) {
    localStorage.removeItem("persist:demo1-auth");
    localStorage.clear();
    sessionStorage.clear();

    clearAllCookies();

    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
        console.log("Browser cache cleared.");
      } catch (error) {
        console.error("Failed to clear browser cache:", error);
      }
    }

    console.log("Cache, storage, and cookies cleared.");
    localStorage.setItem("lastClearDate", todayString);
    localStorage.setItem("nextPollSinceTimestamp", nextPollSinceTimestamp);
    localStorage.setItem("persisted_sale_orders", preserveSaleOrder);
    localStorage.setItem("persisted_purchase_orders", preservePurchaseOrder);
    localStorage.setItem(BANKING_BALANCE_VISIBILITY_KEY, JSON.stringify(false));

    window.location.reload();
  }
};

const clearAllCookies = () => {
  const cookies = document.cookie.split(";");

  cookies.forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });
};

clearAppStorageAndCacheDaily();

_redux.setupAxios(axios, store);

// setTimeout(() => {
if (window !== window.top && JSON.parse(localStorage.getItem("persist:demo1-auth")).user) {
  window.parent.postMessage(
    {
      sale_agent: localStorage.getItem("persist:demo1-auth"),
      portal_url: `${JSON.parse(localStorage.getItem("immutable_basic_settings"))?.portal_url || "https://stag.pkhub.app"}`,
    },
    `${JSON.parse(localStorage.getItem("immutable_basic_settings"))?.ecom_url || "https://stag-ecom.pkhub.app"}`
  );
}
// }, 0);

// Listen for token requests from CRM (if embedded in iframe)
// This ensures CRM uses the same authentication tokens as kapp/client
window.addEventListener('message', (event) => {
  // Only respond to requests from same origin or trusted origins
  if (event.data && event.data.type === 'CRM_REQUEST_TOKENS') {
    const state = store.getState();
    // Use the exact same tokens that kapp/client uses for its API calls
    const authToken = state?.auth?.authToken;
    const refreshToken = state?.auth?.refreshToken;
    
    if (authToken) {
      // Send the same tokens to CRM that kapp/client uses
      event.source.postMessage({
        type: 'CRM_TOKENS_RESPONSE',
        access_token: authToken,  // Same token used in kapp/client API calls
        refresh_token: refreshToken,  // Same refresh token used in kapp/client
      }, event.origin);
    }
  }
});

ReactDOM.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <App store={store} persistor={persistor} basename={PUBLIC_URL} />
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>,
  document.getElementById("root")
);
